// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--tTAa8","basicInfo":"basicInfo--ttQcq","card":"card--enGaY","markerAnimationScale":"markerAnimationScale--PyRFG"};